export const pathnames = ["/", "/cashmere", "/products", "/contacts"]
export const baseurl = "https://www.woolcashmerepratese.com"
